import { useCallback, useState } from 'react';

const withLoading =
  ({ loadingClassName }) =>
  WrappedComponent => {
    const ComponentWithLoading = props => {
      const [isLoaded, setIsLoaded] = useState(false);

      const handleLoad = useCallback(() => {
        setIsLoaded(true);
      }, []);

      return (
        <WrappedComponent
          {...props}
          isLoaded={isLoaded}
          handleLoad={handleLoad}
          loadingClassName={isLoaded ? loadingClassName : ''}
        />
      );
    };
    return ComponentWithLoading;
  };

export default withLoading;
